import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  font-family: "Roboto Condensed", arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #333333;
  margin-bottom: 60px;
`;

export const Header = styled.div`
  margin-bottom: 50px;
`;

export const ListLoading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  img {
    width: 50px;
    height: 50px;
  }
`;

export const Close = styled.div`
  visibility: visible;
  flex: 0.5;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  svg {
    width: 10px;
    height: 10px;
    fill: #333333;
    cursor: pointer;
  }
`;

export const Title = styled.span`
  font-weight: bold;
  font-size: 24px;
`;

export const SubTitle = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
`;

export const SubTitleSpan = styled.span`
  font-weight: normal;
  text-transform: none;
`;

export const ShareContainer = styled.div`
  width: 100%;
  margin-top: 15px;
`;

export const ShareText = styled.span`
  font-family: "Roboto Condensed", arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
  color: #333333;
  margin-bottom: 5px;
`;

export const ShareButton = styled.div`
  button > svg {
    circle {
      stroke: #d0ccc8;
      stroke-width: 4px;
      fill: none;
      cx: 32;
      cy: 32;
      r: 30;
    }
    path {
      fill: ${({ color }) => color || "#333333"};
    }
  }
  button:hover > svg {
    circle {
      stroke: ${({ color }) => color || "#333333"};
      stroke-width: 4px;
      fill: ${({ color }) => color || "#333333"};
      cx: 32;
      cy: 32;
      r: 30;
    }
    path {
      fill: #ffffff;
    }
  }

  :nth-child(n) {
    margin-left: 5px;
  }
  :first-child {
    margin-left: 0px;
  }
`;

export const ShareButtonsContainer = styled.div`
  width: 100%;
  max-width: 350px;
  display: flex;

  /* less than 576px */
  flex-wrap: wrap;

  /* Medium devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {
    flex-wrap: nowrap;
  }
`;

export const Body = styled.div`
  width: 100%;
`;

export const Description = styled.span`
  font-size: 14px;
  line-height: 24px;
  svg {
    height: 16px;
    width: 16px;
    margin-right: 5px;
    path {
      fill: #333333;
    }
  }
`;

export const DescriptionVideoContainer = styled.div`
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DescriptionVideo = styled.div`
  max-width: 400px;
  width: 100%;
  height: 100%;
  border: none;

  iframe {
    border-radius: 1rem;

    /* less than 768px */
    min-height: 165px;

    /* Medium devices (landscape phones, 576px and up) */
    @media (min-width: 576px) {
      min-height: 225px;
    }
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  font-family: "Roboto Condensed", arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: -0.1px;
  color: #333333;
  margin-top: 50px;

  /* less than 576px */
  flex-direction: column;

  /* Medium devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {
    flex-direction: row;
  }
`;

export const DetailsBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 0.5rem;
`;

export const DetailsBoxHeader = styled.div`
  width: 100%;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 24px;
  padding: 10px 0;
`;

export const DetailsBoxTitle = styled.span`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
  margin-left: 1rem;
`;

export const DetailsBoxBody = styled.div`
  width: 100%;
  padding-top: 15px;
`;

export const DetailsBoxItem = styled.div`
  padding-bottom: 40px;
  padding-left: 15px;
`;

export const DetailsBoxDescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DetailsBoxDescriptionText = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #333333;
  padding-left: 30px;
  margin-bottom: 12px;
`;

export const DetailsBoxDescriptionLevel = styled.div`
  width: 100%;
  margin-left: auto;
  max-width: 120px;
  margin-bottom: 12px;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 250px;
  align-items: center;
  text-aling: center;
`;
